import MultipleClientsReportPage from './MultipleClientsReportPage';

export default MultipleClientsReportPage;


// WEBPACK FOOTER //
// ./src/features/reports/pages/multiple-clients-report/index.js